

































import { Prop, Component, Vue } from "vue-property-decorator";
import { Staff } from "@/api/company-api";

@Component({})
export default class VButtonInvite extends Vue {
  @Prop({ required: true }) target!: Staff;

  ok() {
    (this.$refs.modal as any).hide();
    this.$emit("ok");
  }

  cancel() {
    (this.$refs.modal as any).hide();
    this.$emit("cancel");
  }
}
